<mat-tab-group class="tab" animationDuration="0ms">

  <mat-tab label="Bid Manage">
    <div class="btn-container">
      <button *ngIf="!showForm" class="new-button" (click)="onNew()">Create New Bid Round</button>
    </div>

    <div class="search-label">Search Bid Round</div>
    <form [formGroup]="searchForm" (ngSubmit)="onSearch(searchCurrentPage)">
      <div class="search-form">
        <div class="form-group">
          <label for="bid_status" class="form-label">Bid Status:</label>
          <select id="bid_status" formControlName="bid_status" class="form-control">
            <option *ngFor="let status of bidStatusOptions" [value]="status">{{ status }}</option>
          </select>
        </div>
        <button type="submit" class="search-button">Search</button>
      </div>
    </form>

    <table *ngIf="!showForm" class="table table-striped">
      <thead>
        <tr>
          <th>Start Time</th>
          <th>End Time</th>
          <th>Bid Type</th>
          <th>Start Trade Period</th>
          <th>End Trade Period</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let bidRound of bidRounds">
          <td>{{ bidRound.start_time }}</td>
          <td>{{ bidRound.end_time }}</td>
          <td>{{ bidRound.bid_type }}</td>
          <td>{{ bidRound.start_trade_period }}</td>
          <td>{{ bidRound.end_trade_period }}</td>
          <td>{{ bidRound.status }}</td>
          <td class="action">
            <button (click)="onEdit(bidRound)" class="btn btn-primary">Edit</button>
            <button (click)="onDelete(bidRound.id)" class="btn btn-danger">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- <app-pagination
    [totalItems]="totalItems"
    [itemsPerPage]="itemsPerPage"
    [currentPage]="currentPage"
    (pageChanged)="onPageChanged($event)">
  </app-pagination> -->
    <app-search-pagination [totalSearchItems]="totalSearchItems" [searchItemsPerPage]="searchItemsPerPage"
      [SearchCurrentPage]="searchCurrentPage" (searchPageChanged)="onSearchChanged($event)">
    </app-search-pagination>

    <div *ngIf="showForm" class="form-section">
      <h2>{{ isEdit ? 'Update Bid Round' : 'Create Bid Round' }}</h2>
      <form [formGroup]="bidRoundForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <div class="form-field">
            <label for="start_time" class="form-label">Start Time:</label>
            <input type="datetime-local" id="start_time" formControlName="start_time" class="form-control"
              [min]="minDate" />
          </div>
          <div class="form-field">
            <label for="end_time_time" class="form-label">End Time:</label>
            <input type="datetime-local" id="end_time" formControlName="end_time" class="form-control"
              [min]="bidRoundForm.value.start_time" />
          </div>
        </div>

        <div class="form-group">
          <div class="form-field">
            <label for="start_trade_period" class="form-label">Start Trade Period:</label>
            <input type="datetime-local" id="start_trade_period" formControlName="start_trade_period"
              class="form-control" [min]="bidRoundForm.value.end_time" />
          </div>
        </div>

        <div class="form-group">
          <div class="form-field">
            <label for="end_trade_period" class="form-label">End Trade Period:</label>
            <input type="datetime-local" id="end_trade_period" formControlName="end_trade_period" class="form-control"
              [min]="bidRoundForm.value.start_trade_period" />
          </div>
          <div class="form-field">
            <label for="bid_type" class="form-label">Bid Type:</label>
            <select id="bid_type" formControlName="bid_type" class="form-control">
              <option *ngFor="let type of bidTypeOptions" [value]="type">{{ type }}</option>
            </select>
          </div>
        </div>

        <div class="form-group" *ngIf="isEdit">
          <div class="form-field">
            <label for="bid_status" class="form-label">Status:</label>
            <select id="bid_status" formControlName="status" class="form-control">
              <option *ngFor="let status of bidStatusOptions" [value]="status">{{ status }}</option>
            </select>
          </div>
        </div>
        <div class="form-actions">
          <button type="button" class="cancel-button" (click)="onCancel()">Cancel</button>
          <button type="submit" class="submit-button">{{ isEdit ? 'Update' : 'Create' }}</button>
        </div>
      </form>
      <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
    </div>

  </mat-tab>


  <mat-tab label="Bid History">

    <div class="history-container">
      <div class="table-container" *ngIf=" completedBidRound.length > 0">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Status</th>
              <th>Strike Price</th>
              <th>Bid Type</th>
              <th>Start Trade Period</th>
              <th>End Trade Period</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let bid of completedBidRound">
              <td>{{ bid.id }}</td>
              <td>{{ bid.start_time }}</td>
              <td>{{ bid.end_time }}</td>
              <td>{{ bid.status }}</td>
              <td>{{ bid.strike_price}}</td>
              <td>{{ bid.bid_type}}</td>
              <td>{{ bid.start_trade_period}}</td>
              <td>{{ bid.end_trade_period}}</td>


            </tr>




            <tr *ngFor="let bid of tradedBidRound">
              <td>{{ bid.id }}</td>
              <td>{{ bid.start_time }}</td>
              <td>{{ bid.end_time }}</td>
              <td>{{ bid.status }}</td>
              <td>{{ bid.strike_price}}</td>
              <td>{{ bid.bid_type}}</td>
              <td>{{ bid.start_trade_period}}</td>
              <td>{{ bid.end_trade_period}}</td>


            </tr>

          </tbody>
        </table>
      </div>
      <div *ngIf="completedBidRound.length === 0">No bids available.</div>
    </div>

    <app-pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage"
      (pageChanged)="onPageChanged($event)">
    </app-pagination>
  </mat-tab>

  <mat-tab label="User Administration">
    <div class="history-container">
      <!-- <div *ngIf="error" class="error">{{ error }}</div> -->
      <div class="table-container" *ngIf="userList.length > 0">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>User Name</th>
              <th>Phone Number</th>
              <th>Connection Number</th>
              <th>Meter Number</th>
              <th>Email</th>
              <th>Address</th>
              <th>State</th>
              <th>Locality</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of userList">
              <td>{{ user.id }}</td>
              <td>{{ user.name }}</td>
              <td>{{ user.phone_number }}</td>
              <td>{{ user.connection_number }}</td>
              <td>{{ user.meter_number }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.address }}</td>
              <td>{{ user.state }}</td>
              <td>{{ user.locality }}</td>
              <td class="action">
                <button (click)="editUser(user.id)" class="btn btn-primary">Edit</button>
                <button (click)="deleteUser(user.id)" class="btn btn-danger">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="userList.length === 0">No User Registered.</div>
    </div>

    <div *ngIf="showUserForm" class="user-section">

      <form [formGroup]="userForm" (ngSubmit)="userSubmit()">
        <div class="form-group">
          <div class="form-field">
            <label for="group_id" class="form-label">Group Id:</label>
            <!-- <input type="text" id="group_id" formControlName="group_id" class="form-control"/> -->
            <select id="bid_status" formControlName="group_id" class="form-control">
              <option *ngFor="let group of userGroupList; let i = index" [value]="i+1">{{ group }}</option>
            </select>
          </div>
        </div>

        <div class="form-actions">
          <button type="button" class="cancel-button" (click)="onCancel()">Cancel</button>
          <button type="submit" class="submit-button">Update</button>
        </div>
      </form>
    </div>

  </mat-tab>


</mat-tab-group>
